import { runGetLocation } from '../lib/funnels/functions/v1/default/runGetLocation'
import { setUpFormInputs } from '../lib/funnels/functions/v1/html/setupFormInputs'
import { populateFormPrefills } from '../lib/funnels/functions/v1/html/populateFormPrefills'

const SESSION_ID = 'tdMainFunnel'

runGetLocation(SESSION_ID)

document.addEventListener('DOMContentLoaded', () => {
  setUpFormInputs()
  populateFormPrefills(SESSION_ID)
})
